export default __webpack_public_path__ + "static/04-Produtos_de_Limpeza--8159b1b97c9e2cf4e2d8bb7e6f2c605a.jpg";